module.exports = __webpack_public_path__ + "img/REG_ALIM_SANS_POISSON_LISTE_NOM.698008bb.svg";